export default "__VITE_ASSET__e87a12f9__"